export class SearchFiltersHandler {
  constructor(storageKey, defaultFilters = {}) {
    this.storageKey = storageKey
    this.defaultFilters = defaultFilters
  }

  /**
   * Save filters to localStorage
   * @param {Object} filters - The filter object to save
   */
  saveFilters(filters) {
    try {
      const filtersToSave = {
        search: { ...filters }
      }
      localStorage.setItem(this.storageKey, JSON.stringify(filtersToSave))
    } catch (error) {
      console.warn(`Failed to save filters to localStorage (${this.storageKey}):`, error)
    }
  }

  /**
   * Load filters from localStorage
   * @returns {Object|null} - The loaded filters or null if not found
   */
  loadFilters() {
    try {
      const savedFilters = localStorage.getItem(this.storageKey)
      if (savedFilters) {
        const parsed = JSON.parse(savedFilters)
        return {
          search: parsed.search || { ...this.defaultFilters }
        }
      }
    } catch (error) {
      console.warn(`Failed to load filters from localStorage (${this.storageKey}):`, error)
    }
    return null
  }

  /**
   * Clear filters from localStorage
   */
  clearFilters() {
    try {
      localStorage.removeItem(this.storageKey)
    } catch (error) {
      console.warn(`Failed to clear filters from localStorage (${this.storageKey}):`, error)
    }
  }

  /**
   * Check if filters are empty based on the default values
   * @param {Object} filters - The current filter values
   * @returns {boolean} - True if filters are empty/default
   */
  areFiltersEmpty(filters) {
    const emptyBooleans = Object.entries(this.defaultFilters)
      .filter(([_, value]) => value === false)
      .map(([key]) => key)

    const isEmpty = (key, value) => {
      if (value === null || value === undefined) return true

      if (typeof value === 'string') {
        const trimmed = value.trim().toLowerCase()
        if (trimmed === "" || trimmed === "nan" || trimmed === "invalid date" || trimmed === "false" || trimmed === "0") {
          return true
        }
      } else if (typeof value === 'number' && (isNaN(value) || value === 0)) {
        return true
      } else if (Array.isArray(value) && value.length === 0) {
        return true
      } else if (value === false && emptyBooleans.includes(key)) {
        return true
      }

      return false
    }

    const nonEmptyKeys = Object.keys(this.defaultFilters).filter(key => !isEmpty(key, filters[key]))

    return nonEmptyKeys.length === 0
  }
}

export function createFiltersHandler(storageKey, defaultFilters = {}) {
  return new SearchFiltersHandler(storageKey, defaultFilters)
}
